import { computed } from "vue";
import { useEventStore } from "../stores/events";
import type { Event } from "../types";

const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const
type Day = typeof days[number]

/** JavaScript's modulo operator can return negative values, so we need to use a custom modulo function to always return a positive value. */
function realModulo(a: number, b: number) {
  return ((a % b) + b) % b;
}

/** 
 * We want an event happening on saturday 01:00 AM to show up on friday's program. 
 * The limit is 4 AM, so if the event is on saturday 04:00 AM, it will show up on saturday's program.
 */
function getEventDay(timestamp: string): Day {
  const date = new Date(timestamp);
  const hour = date.getHours();
  const actualDayIndex = date.getDay();

  if (hour < 4) {
    return days[realModulo(actualDayIndex - 1, 7)];
  } 
  return days[actualDayIndex];
}

export function useProgramEvents() {
  const eventStore = useEventStore()

  const events = eventStore.events

  const eventsByDay = computed(() => {
    const eventsByDay: Record<Day, Event[]> = {
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
    }

    for (const event of events) {
      const eventDay = getEventDay(event.timestamp)
      eventsByDay[eventDay].push(event)
    }

    return [
      // We don't want to show events from sunday or monday.
      // eventsByDay.sunday,
      // eventsByDay.monday,
      eventsByDay.tuesday,
      eventsByDay.wednesday,
      eventsByDay.thursday,
      eventsByDay.friday,
      eventsByDay.saturday,
    ]
  })

  return {
    eventsByDay,
    events,
  }

}